import store from "@/store";
import router from "@/router";
import errors from "@/services/errors";
//import axios from "axios";
//import firebase from "firebase/app";
//import "firebase/auth";
//import "firebase/database";
//import "firebase/storage";

/*
const config = {
  apiKey: "AIzaSyCeLqjz2dOqZ2K1_33dQwVmEYcq2ZYm08I",
  authDomain: "portal-pagos.firebaseapp.com",
  databaseURL: "https://portal-pagos.firebaseio.com",
  projectId: "portal-pagos",
  storageBucket: "portal-pagos.appspot.com",
  messagingSenderId: "334687719686",
  appId: "1:334687719686:web:676eb3c4655b5140"
};*/

export default {
  install: (Vue, options) => {
    //const firebaseApp = firebase.initializeApp(config);
    //const auth = firebaseApp.auth();
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        //return auth.signInWithEmailAndPassword(username, pass);
        const formData = {
          email: username,
          password: pass
        };
        try {
          const response = await Vue.prototype.$axios.post(
            "/auth/login",
            formData
          );
          if (response.status != 200) {
            const error = new Error(response.data.message);
            error.status = response.status;
            error.response = response;
            throw error;
          }

          const expirationDate = new Date(response.data.expirationDate * 1000);
          localStorage.setItem(
            "app.settings.accounts",
            JSON.stringify(response.data.accounts)
          );
          localStorage.setItem(
            "app.settings.gatewayId",
            response.data.gatewayId
          );
          localStorage.setItem("app.settings.userId", response.data.userId);
          localStorage.setItem("app.settings.userName", response.data.userName);
          localStorage.setItem("app.settings.token", response.data.token);
          localStorage.setItem("app.settings.expirationDate", expirationDate);

          Vue.prototype.$axios.defaults.headers.common = {
            // eslint-disable-next-line prettier/prettier
              "Authorization": "Bearer " + response.data.token
          };
          let payload = {
            accounts: response.data.accounts,
            gatewayId: response.data.gatewayId,
            userId: response.data.userId,
            userName: response.data.userName,
            token: response.data.token
          };
          store.dispatch("users/authUser", payload);
          return payload;
        } catch (err) {
          throw err;
        }
      },
      isAuthenticated: () => {
        //many returns in this function to make it faster
        //it's a core function to be executed in every single route
        if (store.state.users.token) {
          // eslint-disable-next-line prettier/prettier
          return true;
        } else if (
          localStorage.getItem("app.settings.token") &&
          localStorage.getItem("app.settings.token") != ""
        ) {
          // eslint-disable-next-line prettier/prettier
          const expirationDate = new Date(localStorage.getItem("app.settings.expirationDate"));
          const now = new Date();
          if (now < expirationDate) {
            store.dispatch("users/authUser", {
              accounts: JSON.parse(
                localStorage.getItem("app.settings.accounts")
              ),
              gatewayId: localStorage.getItem("app.settings.gatewayId"),
              userId: localStorage.getItem("app.settings.userId"),
              userName: localStorage.getItem("app.settings.userName"),
              token: localStorage.getItem("app.settings.token")
            });
            // eslint-disable-next-line prettier/prettier
            //Vue.prototype.$axios.defaults.headers.common = { "Authorization": `Bearer ${store.state.users.token}` };
            Vue.prototype.$axios.defaults.headers.common = {
              // eslint-disable-next-line prettier/prettier
              "Authorization": "Bearer " + localStorage.getItem("app.settings.token")
            };
            return true;
          }
        }
        return false;
      },
      logout: async () => {
        await store.dispatch("users/logoutUser");
        localStorage.setItem("app.settings.accounts", "");
        localStorage.setItem("app.settings.gatewayId", "");
        localStorage.setItem("app.settings.userId", "");
        localStorage.setItem("app.settings.userName", "");
        localStorage.setItem("app.settings.token", "");
        localStorage.setItem("app.settings.expirationDate", "");
        router.push("/user/login");
      },
      restorePassword: async email => {
        const formData = {
          email
        };
        return await Vue.prototype.$axios
          .post("/auth/restore-password", formData)
          .then(response => {
            return response.data.message;
          })
          .catch(error => {
            throw error;
          });
      },
      newPassword: async (password1, password2, token) => {
        const formData = {
          password1,
          password2,
          token
        };
        return await Vue.prototype.$axios
          .post("/auth/new-password", formData)
          .then(response => {
            return response.data;
          })
          .catch(error => {
            throw error;
          });
      },
      switchAccount: async accountId => {
        try {
          const x = 10;
          const response = await Vue.prototype.$axios.post(
            `/users/switch-account/${accountId}`
          );
          if (response.status != 201) {
            const err = errors.handleHTTPError(response);
            throw err;
          }
          const expirationDate = new Date(response.data.expirationDate * 1000);
          localStorage.setItem(
            "app.settings.accounts",
            JSON.stringify(response.data.accounts)
          );
          localStorage.setItem(
            "app.settings.gatewayId",
            response.data.gatewayId
          );
          localStorage.setItem("app.settings.userId", response.data.userId);
          localStorage.setItem("app.settings.userName", response.data.userName);
          localStorage.setItem("app.settings.token", response.data.token);
          localStorage.setItem("app.settings.expirationDate", expirationDate);

          Vue.prototype.$axios.defaults.headers.common = {
            // eslint-disable-next-line prettier/prettier
              "Authorization": "Bearer " + response.data.token
          };
          let payload = {
            accounts: response.data.accounts,
            gatewayId: response.data.gatewayId,
            userId: response.data.userId,
            userName: response.data.userName,
            token: response.data.token
          };
          store.dispatch("users/authUser", payload);
          return payload;
        } catch (err) {
          throw err;
        }
      }
    };
    /*
    auth.onAuthStateChanged(user => {
      store.commit("UPDATE_USER", { user });
    });*/
  }
};
